import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './cons-card-type.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsCardTypeDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const consCardTypeEntity = useAppSelector(state => state.consCardType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="consCardTypeDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.consCardType.detail.title">ConsCardType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{consCardTypeEntity.id}</dd>

          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.consCardType.code">Code</Translate>
            </span>
          </dt>
          <dd>{consCardTypeEntity.code}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.consCardType.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{consCardTypeEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.consCardType.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{consCardTypeEntity.nameEn}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.consCardType.name">Name</Translate>
            </span>
          </dt>
          <dd>{consCardTypeEntity.name}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.consCardType.status">Status</Translate>
            </span>
          </dt>
          <dd>{consCardTypeEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/cons-card-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/cons-card-type/${consCardTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConsCardTypeDetail;
